import type { ReactNode } from 'react';
import classes from './IdText.module.css';

interface IdTextProps {
  readonly children: ReactNode;
}

// Машинный идентификатор, который сверяют по символам: номер сделки (без «№»), ИНН, КПП, ОГРН, счёт, БИК, API-ключ,
// номер заявки. Цены, даты и объёмы им не оформляются. См. design-guidelines.
export default function IdText({ children }: IdTextProps) {
  return <span className={classes.id}>{children}</span>;
}
